// extracted by mini-css-extract-plugin
export default {"box":"Area_box__kaBQ1","content":"Area_content__Vouea","chart":"Area_chart__RwW-h"};